import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito experiencia o conocimientos previos?',
    a: 'No. El grimorio está diseñado para principiantes absolutas. Cada módulo te guía paso a paso, desde qué es un grimorio hasta tu primer ritual. Si nunca hiciste nada relacionado con la brujería, este es exactamente el lugar para empezar.'
  }, {
    q: '¿Necesito comprar cristales, velas o herramientas especiales?',
    a: 'No. Todos los rituales están diseñados con ingredientes que ya tenés en tu cocina: ruda, romero, sal, laurel. Si querés sumar herramientas después, el grimorio te guía, pero no es requisito para empezar.'
  }, {
    q: '¿Es Wicca? ¿Tengo que creer en diosas o deidades?',
    a: 'No. El grimorio es inclusivo y no está atado a ninguna religión o tradición específica. Funciona tanto si creés en deidades como si preferís un enfoque secular o psicológico. Tu práctica, tus reglas.'
  }, {
    q: '¿Por qué "del Sur"? ¿Qué tiene de diferente?',
    a: 'La mayoría del material sobre brujería está creado para el hemisferio norte. Las estaciones están invertidas, las hierbas son diferentes, las lunas no coinciden. Este grimorio está hecho desde y para el hemisferio sur: calendario lunar real, hierbas locales, estaciones como las vivimos acá.'
  }, {
    q: '¿Cómo recibo el grimorio después de comprar?',
    a: 'El acceso es inmediato. Tras tu compra recibís un mail con el link de descarga directa. Podés verlo en celular, tablet o computadora, e imprimirlo cuando quieras.'
  }, {
    q: '¿Puedo practicar si vivo con gente que no lo entiende?',
    a: 'Sí. El grimorio es digital y discreto. Muchos rituales se pueden hacer en silencio, con ingredientes cotidianos que no levantan sospechas.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tu compra está protegida. Si en 7 días no estás satisfecha, nos mandás un mail y te devolvemos el dinero completo. Sin preguntas.'
  }];
  return <section className="py-12 px-4 relative z-10" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="font-cormorant text-4xl md:text-5xl text-center text-gold-light mb-8" data-id="element-53">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="border border-gold-dark/20 rounded-lg overflow-hidden bg-mystic-surface/50" data-id="element-55">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-mystic-surfaceDark transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56">
                <span className="font-medium text-text-primary pr-8" data-id="element-57">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-primary shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 py-4 border-t border-gold-dark/10' : 'max-h-0'}`} data-id="element-59">
                <p className="text-text-soft leading-relaxed" data-id="element-60">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};